module.exports = {
  ent_o_meta_description: 'Keeta 企業版為企業提供靈活的餐飲津貼和報銷管理工具，簡化行政流程，提高員工滿意度。通過自訂津貼規則、簡單易用的操作界面、以及高效的報銷流程，幫助企業節省時間並提升效率。適合各種企業需求，提供員工多樣的餐飲選擇，並保障數據安全與透明。',
  ent_o_meta_keywords: 'Keeta 企業版, 餐飲津貼, 報銷管理, 企業福利, 簡化流程, 員工滿意度, 自訂津貼, 報銷自動化, 易用界面, 企業管理工具, 靈活規則配置, 實時報告, 數據管理, 餐飲選擇',
  ent_o_page_title: 'Keeta 企業版 - 輕鬆管理員工津貼',
  ent_o_nav_logo: 'Keeta 企業版',
  ent_o_nav_contact: '聯繫我們',
  ent_o_nav_login: '賬戶登錄',
  ent_o_hero_title: '使用 Keeta 企業版<br>輕鬆管理員工津貼',
  ent_o_hero_subtitle: '提供靈活津貼和報銷管理，簡化行政工作，提升員工滿意度。',
  ent_o_features_title: '為什麼選擇 Keeta 企業版？',
  ent_o_features_cards_0_title: '靈活管理，輕鬆設置',
  ent_o_features_cards_0_desc: '提供自訂津貼與報銷規則，滿足各種需求。',
  ent_o_features_cards_1_title: '簡化流程，提高效率',
  ent_o_features_cards_1_desc: '自動處理報銷，減少繁瑣工作，提升效率。',
  ent_o_features_cards_2_title: '多樣選擇，員工滿意',
  ent_o_features_cards_2_desc: '聚合餐廳與外賣，滿足員工個性化需求。',
  ent_o_features_cards_3_title: '簡單易用，快速上手',
  ent_o_features_cards_3_desc: '直觀的操作界面，讓企業管理者無需繁複學習，即可輕鬆設置與管理。',
  ent_o_benefits_title: 'Keeta 企業版的優勢',
  ent_o_benefits_items_0_title: '定制津貼管理工具',
  ent_o_benefits_items_0_desc: '輕鬆設定員工餐飲津貼，滿足各部門不同需求，精準控制預算。',
  ent_o_benefits_items_1_title: '多元商家選擇平台',
  ent_o_benefits_items_1_desc: '餐廳選擇多樣，讓員工能夠享受更多元的餐飲，提升用餐體驗。',
  ent_o_benefits_items_2_title: '智能報銷流程設置',
  ent_o_benefits_items_2_desc: '自動化報銷申請流程，讓管理更加高效，減少人工操作。',
  ent_o_benefits_items_3_title: '靈活規則配置平台',
  ent_o_benefits_items_3_desc: '根據公司需求靈活設置津貼和報銷規則，讓管理更加便捷。',
  ent_o_benefits_items_4_title: '簡單操作界面',
  ent_o_benefits_items_4_desc: '直觀的界面設計，讓管理者快速上手，輕鬆管理餐飲津貼和報銷規則。',
  ent_o_cta_title: '今天就開始使用 Keeta 企業版',
  ent_o_contact_title: '聯絡銷售',
  ent_o_contact_subtitle: '如果你有興趣了解更多有關 Keeta 企業版的資訊，請跟我們聯繫。',
  ent_o_contact_form_placeholder: '請輸入',
  ent_o_contact_form_validation_required: '請填寫該項',
  ent_o_contact_form_validation_invalidEmail: '請輸入有效的電子郵件地址',
  ent_o_contact_form_validation_fillIn: '請填寫',
  ent_o_contact_form_validation_incorrectInfo: '信息填寫錯誤，請檢查',
  ent_o_contact_form_firstName: '名字',
  ent_o_contact_form_lastName: '姓氏',
  ent_o_contact_form_email: '商用電子郵件',
  ent_o_contact_form_phone_label: '電話號碼',
  ent_o_contact_form_phone_placeholder: '請輸入手機號碼 (例如 +852 9123 4567)',
  ent_o_contact_form_phone_invalidPhone: "請輸入有效的電話號碼",
  ent_o_contact_form_company: '公司名稱',
  ent_o_contact_form_size_label: '公司人數',
  ent_o_contact_form_size_placeholder: '請選擇',
  ent_o_contact_form_size_options_1: '1 - 50人',
  ent_o_contact_form_size_options_2: '51 - 200人',
  ent_o_contact_form_size_options_3: '201 - 500人',
  ent_o_contact_form_size_options_4: '501 - 1000人',
  ent_o_contact_form_size_options_5: '1000人以上',
  ent_o_contact_form_usage_label: '使用頻率',
  ent_o_contact_form_usage_placeholder: '請選擇',
  ent_o_contact_form_usage_options_1: '定期提供餐點給他人（例如，辦公室餐點、加班餐點等）',
  ent_o_contact_form_usage_options_2: '定期提供津貼給他人（例如，整月用餐津貼等）',
  ent_o_contact_form_usage_options_3: '臨時提供餐點給他人（例如，活動、會議等）',
  ent_o_contact_form_submit: '提交信息',
  ent_o_contact_form_submitSuccess: '提交成功！我們的銷售代表會儘快聯繫您。',
  ent_o_footer_links_about: '關於我們',
}